import { useQuery, useQueryClient } from '@tanstack/react-query'

import { useMst } from '#state/MstContext'

const queryKey = ['staff.listFormats']
export const useStaffFormats = () => {
  const { scrapi } = useMst()
  const queryClient = useQueryClient()
  const formatsQuery = useQuery({
    queryFn: async () => {
      const result = await scrapi.staff.listFormats()
      if (result.status === 200) {
        return result.body.formats
      }
      throw new Error('Unexpected result', { cause: result })
    },
    queryKey,
  })

  const refresh = () => {
    queryClient.refetchQueries({ queryKey })
  }

  return {
    refresh,
    formatsQuery,
  }
}

const detailQueryKey = ['staff.getFormat']
export const useStaffFormat = (id: string) => {
  const { scrapi } = useMst()
  const queryClient = useQueryClient()
  const formatQuery = useQuery({
    queryFn: async () => {
      const result = await scrapi.staff.getFormat({ params: { id } })
      if (result.status === 200) {
        return result.body
      }
      throw new Error('Unexpected result', { cause: result })
    },
    queryKey: detailQueryKey.concat(id),
  })

  const refresh = () => {
    queryClient.refetchQueries({ queryKey: detailQueryKey })
  }

  return {
    refresh,
    formatQuery,
  }
}
